export default "__VITE_PUBLIC_ASSET__fdef95e1__"